import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function BubbleItem({ children, className, as, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames("cvr-bubble-item", className), ...rest, children: children }));
}
